// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10sXA","newExpiryDate":"styles_newExpiryDate__22jKS","footer":"styles_footer__1VXsp"};